import React from "react";
import { Layout } from "react-admin";
import SupplierSidebar from "./SupplierSidebar";
import SupplierAppBar from "./SupplierAppBar";

const drawerWidth = 268;

export default function SupplierLayout(props) {
  return (
    <Layout
      {...props}
      appBar={SupplierAppBar}
      sidebar={(sidebarProps) => <SupplierSidebar {...sidebarProps} size={drawerWidth} />}
      sx={{
        bgcolor: "background.default",
        "& .RaLayout-appBar": {
          display: { xs: "flex", md: "none" },
        },
        "& .RaLayout-appFrame": {
          marginTop: { md: 0 },
        },
        "& .RaLayout-content": {
          bgcolor: "background.default",
          minWidth: 0,
          px: { xs: 2, sm: 2.5, md: 4 },
          py: { xs: 2, sm: 2.5, md: 4 },
          pt: { xs: 9, md: 4 },
        },
      }}
    />
  );
}
